import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useWealth } from '../../api';
import { WealthOverviewTotalDataItem } from './WealthOverviewTotalDataItem';

interface IProps {
    clientCurrency?: string;
}

export const WealthOverviewTotalData: FunctionComponent<IProps> = ({ clientCurrency }) => {
    const { t } = useTranslation();
    const { assetsTotal, expensesTotal, incomeTotal, liabilitiesTotal } = useWealth();

    return (
        <div className="wealth-overview__total-wealth-container">
            <WealthOverviewTotalDataItem label={t('wealthTotalNet')} amount={assetsTotal - liabilitiesTotal} currency={clientCurrency} />
            <WealthOverviewTotalDataItem label={t('wealthTotalAssets')} amount={assetsTotal} currency={clientCurrency} />
            <WealthOverviewTotalDataItem label={t('wealthTotalLiabilities')} amount={liabilitiesTotal} currency={clientCurrency} />
            <WealthOverviewTotalDataItem label={t('wealthTotalIncome')} amount={incomeTotal} currency={clientCurrency} />
            <WealthOverviewTotalDataItem label={t('wealthTotalExpenses')} amount={expensesTotal} currency={clientCurrency} />
        </div>
    );
};
